import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/ui-bits";

const CanadaOps = () => {
  return (
    <section data-testid="canada-ops-section" aria-labelledby="canada-heading" className="border-t border-[#e5e7eb] bg-[#f7f8f9] py-16 sm:py-20 lg:py-24">
      <div className="container-30 grid items-center gap-12 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-5">
          <Eyebrow>Where We Operate</Eyebrow>
          <h2
            id="canada-heading"
            data-testid="canada-headline"
            className="mt-6 text-3xl font-extrabold leading-[1.08] tracking-tight text-[#191c1e] sm:text-4xl lg:text-5xl"
          >
            MOVING FREIGHT ACROSS CANADA
          </h2>
          <p className="mt-6 text-base leading-relaxed text-[#5f666d] sm:text-lg">
            Based in Ontario, 30 NORTH provides transportation solutions for customers moving freight across Canada.
          </p>
          <div className="mt-10 flex items-center gap-4" data-testid="canada-emphasis">
            <span className="bg-[#191c1e] px-5 py-3 text-[13px] font-bold tracking-[0.16em] text-white">ONTARIO</span>
            <ArrowRight className="h-5 w-5 text-[#ff6a00]" aria-hidden="true" />
            <span className="border border-[#191c1e]/25 px-5 py-3 text-[13px] font-bold tracking-[0.16em] text-[#191c1e]">
              CANADA
            </span>
          </div>
        </Reveal>
        <Reveal delay={0.12} className="lg:col-span-7">
          <figure className="border border-[#e5e7eb] bg-white p-4 sm:p-6" data-testid="canada-map-frame">
            <img
              src="/assets/canada-map.webp"
              alt="Stylized map of Canada highlighting Ontario as 30 NORTH's home base with routes extending across the country"
              data-testid="canada-map-image"
              className="h-auto w-full"
              loading="lazy"
            />
            <figcaption className="mt-4 flex items-center gap-3 px-1 pb-1 text-xs tracking-[0.14em] text-[#5f666d]">
              <span className="block h-1.5 w-1.5 bg-[#ff6a00]" aria-hidden="true" />
              HOME BASE: MISSISSAUGA, ONTARIO
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </section>
  );
};

export default CanadaOps;
